var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.data.nodeId,
      staticClass: "yxtbiz-category-tree-node",
      attrs: { draggable: _vm.showSort },
      on: {
        dragstart: function ($event) {
          $event.stopPropagation()
          return _vm.handleDragStart.apply(null, arguments)
        },
        dragover: function ($event) {
          $event.stopPropagation()
          return _vm.handleDragOver.apply(null, arguments)
        },
        dragenter: function ($event) {
          $event.stopPropagation()
          _vm.draggingTag = false
        },
        dragleave: function ($event) {
          $event.stopPropagation()
          _vm.draggingTag = false
        },
        drop: function ($event) {
          $event.stopPropagation()
          return _vm.handleDrop.apply(null, arguments)
        },
      },
    },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.draggingTag && _vm.dragDerection === "up",
            expression: "draggingTag && dragDerection === 'up'",
          },
        ],
        staticClass: "drag-line",
      }),
      _c(
        "div",
        {
          staticClass: "yxtbiz-category-tree-node-item",
          class: {
            "is-active": _vm.state.active,
          },
          style: "padding-left: " + (20 * _vm.index + 8) + "px",
          on: { click: _vm.onClick },
        },
        [
          _vm.showSort
            ? _c("yxt-svg", {
                staticClass: "color-gray-6 sort-svg",
                attrs: { "icon-class": "sort", width: "16px", height: "16px" },
              })
            : _vm._e(),
          _c(
            "span",
            {
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.changeExpanded(!_vm.expanded)
                },
              },
            },
            [
              _c("yxt-svg", {
                staticClass:
                  "expand-svg color-gray-6 hover-primary-6 hover-pointer",
                class: {
                  visible: _vm.data.hasChild,
                },
                attrs: {
                  "icon-class": _vm.expanded ? "down" : "common_right",
                  width: "16px",
                  height: "16px",
                },
              }),
            ],
            1
          ),
          _vm.multiple
            ? _c(
                "div",
                { staticClass: "ml4 mr4" },
                [
                  _c("yxt-checkbox", {
                    on: { change: _vm.handleChecked },
                    model: {
                      value: _vm.state.checked,
                      callback: function ($$v) {
                        _vm.$set(_vm.state, "checked", $$v)
                      },
                      expression: "state.checked",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "node-name ml4" }, [
            _vm._v("\n      " + _vm._s(_vm.data.nodeName) + "\n    "),
          ]),
          _vm.showInsert || _vm.showModified || _vm.showDelete
            ? _c(
                "yxt-dropdown",
                {
                  attrs: { trigger: "hover", "custom-elm": "" },
                  on: { command: _vm.handleSetting },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "setting-svg hover-primary-6 hover-pointer color-gray-6",
                    },
                    [_c("i", { staticClass: "yxt-icon-setting" })]
                  ),
                  _c(
                    "yxt-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _vm.showInsert
                        ? _c(
                            "yxt-dropdown-item",
                            { attrs: { command: "create" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("pc_common_category_insert").d("新增")
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.showModified
                        ? _c(
                            "yxt-dropdown-item",
                            { attrs: { command: "update" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("pc_common_cate_edit").d("编辑"))
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.showDelete
                        ? _c(
                            "yxt-dropdown-item",
                            { attrs: { command: "delete" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("pc_common_category_delete").d("删除")
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.data.hasChild
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.expanded,
                  expression: "expanded",
                },
              ],
              staticClass: "yxtbiz-category-tree-node-child-container",
            },
            _vm._l(_vm.data.children, function (item) {
              return _c("yxtbiz-category-tree-node", {
                key: item.nodeId,
                attrs: {
                  sort: _vm.sort,
                  deleteFunc: _vm.deleteFunc,
                  "get-cate-children": _vm.getCateChildren,
                  "handle-click": _vm.handleClick,
                  "handle-check": _vm.handleCheck,
                  showForm: _vm.showForm,
                  selectedId: _vm.selectedId,
                  checkedIds: _vm.checkedIds,
                  afterDelete: _vm.handleDeleteChild,
                  pnodeId: _vm.data.nodeId,
                  data: item,
                  index: _vm.index + 1,
                  multiple: _vm.multiple,
                  expandAll: _vm.expandAll,
                  sortable: _vm.sortable,
                  firstModifiable: _vm.firstModifiable,
                  modifiable: _vm.modifiable,
                },
                on: { dragStart: _vm.handleDragItemStart },
              })
            }),
            1
          )
        : _vm._e(),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.draggingTag && _vm.dragDerection === "down",
            expression: "draggingTag && dragDerection === 'down'",
          },
        ],
        staticClass: "drag-line",
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }